// @ts-nocheck
import { useEffect, useRef, useState, type ReactNode } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  BookOpen,
  Copy,
  Facebook,
  HeartPulse,
  Images,
  Instagram,
  LayoutGrid,
  PenLine,
  Link2,
  ListTodo,
  MessageCircle,
  MessageSquare,
  Palette,
  Pause,
  Play,
  RefreshCw,
  Settings,
  ShoppingBag,
  Sparkles,
  StickyNote,
  Trash2,
  Wrench,
  type LucideIcon,
} from "lucide-react";
import { api, CarouselItem, type CarouselInspirationBorrow, type CarouselLayoutQa } from "@/lib/api";
import BgPresetPicker from "@/components/BgPresetPicker";
import BgPlacementPicker from "@/components/BgPlacementPicker";
import {
  buildTemplatePatchFromPreset,
  committedPresetId,
} from "@/lib/carouselStyleApply";
import { TONE_CLASS, type SettingsTone } from "@/lib/carouselSettingsMeta";
import { copyText, packFromItem } from "@/lib/carouselGenerationPack";
import {
  recommendCta,
  SOURCE_EMPTY,
  STATUS_TIPS,
  STUDIO_TAB_META,
  STUDIO_TIPS,
  houseCanonState,
  studioTabFromHash,
  studioTabToHash,
  type AbVariable,
  type BgMode,
  type CloseMode,
  type CtaIntent,
  type StudioTab,
} from "@/lib/carouselStudioMeta";
import { type ConceptsTraceOutgoing } from "@/lib/carouselGenerationPack";
import PageHeader from "@/components/PageHeader";
import AiJobModal, { type AiJobKind, type AiJobParam } from "@/components/AiJobModal";
import { AiActionButton, BriefPreview, CopyOutcomePanel, CtaIo, StudioProcessChain, StudioSplit, StudioTabsList } from "@/components/studioTabs";
import { StudioSection } from "@/components/studioVoice";
import { StudioModalBody, StudioModalFooter, StudioModalFrame, StudioModalHeader } from "@/components/StudioModalFrame";
import { DesignAnalysisCard, DesignLayoutNoteCard, HouseCanonBar, StudioOptionCard } from "@/components/DesignReviewPanel";
import CarouselReelPanel from "@/components/CarouselReelPanel";
import { Tabs, TabsContent } from "@/components/ui/tabs";
import { emitInlineMarkdown, type TextMark } from "@/lib/carouselTextMarks";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { InfoTip, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";


import * as Helpers from "../helpers";
const { ideaDescription, firstSlideField, isHeadlineSlide, slideHasCopy, previewMarks, CopyMarkdownCheat, CopyMarkdownField, flattenSlide, FinalSlidesModal, SourceSection, SourceHits, InspirationPanel, Chip, ChoiceCard, CopyPackButton, FieldLabel, TipBadge, CostFooter, tabForExisting, CarouselQueueList, QueueRow } = Helpers;

export default function BriefTab({ ctx }: { ctx: any }) {
  const {
    BORROW_CHIPS,
    DEFAULT_BORROW,
    STATUS_LABEL,
    abPairId,
    abVariable,
    abortLlmM,
    activeMode,
    aiAbort,
    aiError,
    aiFailed,
    aiJob,
    aiJobParams,
    aiStatusLabel,
    analyzeInspM,
    approveM,
    askDelete,
    bgHint,
    bgPresetId,
    bgPlacementId,
    styleApplyMode,
    bgMode,
    book,
    bookHits,
    bookSectionHits,
    borrow,
    borrowM,
    briefBody,
    cancelRenderM,
    caption,
    captionFeedback,
    captionJobSteps,
    captionM,
    captionOnlyJob,
    captionRunning,
    catalog,
    catalogLabel,
    catalogQ,
    catalogTypes,
    changeTrack,
    clickAi,
    closeMode,
    commentHits,
    commitCopyField,
    composeIndex,
    composeMode,
    composeModeM,
    composeSlide,
    conceptsRunning,
    copyApproved,
    copyBusy,
    copyFeedback,
    copyMdRef,
    copyReviseRunning,
    copyRunning,
    copySlides,
    createM,
    ctaIntent,
    ctaM,
    ctaTouched,
    czasotekstFormId,
    setCzasotekstFormId,
    currentQ,
    deleteM,
    designApplyM,
    designApplyRunning,
    designFeedbackM,
    designFixM,
    designFixRunning,
    designQa,
    designReviewM,
    designReviewRunning,
    draftText,
    draftEditMode,
    effectiveClose,
    effectiveIntent,
    finalPreview,
    forcePick,
    formatId,
    fromDraftM,
    fromDraftRunning,
    fromPubM,
    funnel,
    generateCopyM,
    goTab,
    hasComposedSlides,
    hasCopySlides,
    hasSelectedIdea,
    houseCanon,
    inspirationRunning,
    isAiTrack,
    isOperator,
    item,
    itemMode,
    jobRunning,
    layoutPlanM,
    layoutPlanRunning,
    layoutQa,
    layoutQaM,
    layoutQaRunning,
    listQ,
    llmIs,
    mergeCopySlides,
    messengerHits,
    musicStatusQ,
    note,
    openExisting,
    pain,
    patchCopyM,
    pauseM,
    pickTrack,
    painPicked,
    formatPicked,
    funnelPicked,
    skuPicked,
    stylePicked,
    setPainPicked,
    setFormatPicked,
    setFunnelPicked,
    setSkuPicked,
    setStylePicked,
    proposeMusicQ,
    publishBusy,
    publishRunning,
    qaBlocks,
    qaFailed,
    qaLabel,
    qaOverride,
    qc,
    rankingQ,
    ratingM,
    recCta,
    recomposeM,
    reelM,
    reelRunning,
    renderM,
    renderRunning,
    resetStudio,
    retroM,
    retroRunning,
    retryPublishM,
    reviseCopyM,
    scheduleM,
    searchMusicM,
    selectM,
    selectedId,
    selectedIdea,
    setAbPairId,
    setAbVariable,
    setAiJob,
    setBgHint,
    setBgPresetId,
    setBgPlacementId,
    setStyleApplyMode,
    setBgMode,
    setBook,
    setBorrow,
    setCaption,
    setCaptionFeedback,
    setCloseMode,
    setComposeIndex,
    setComposeMode,
    setCopyFeedback,
    setCopySlides,
    setCtaIntent,
    setCtaTouched,
    setDraftText,
    setDraftEditMode,
    setFinalPreview,
    setForcePick,
    setFormatId,
    setFunnel,
    setNote,
    setPain,
    setQaOverride,
    setSelectedId,
    setSku,
    setStudioTab,
    setStyleId,
    setVisualPackId,
    setTool,
    setTraceId,
    setTraceOut,
    setUrls,
    setUseBook,
    setUseComments,
    setUseMessenger,
    setUseStories,
    setVerifyCta,
    setWhen,
    showPicker,
    sku,
    slot,
    slotQ,
    sourceHits,
    sourcesQ,
    startConcepts,
    startPost,
    startCzasotekst,
    czasotekstCopyM,
    statusQ,
    storyHits,
    studio,
    studioTab,
    styleId,
    visualPackId,
    templateM,
    tool,
    traceId,
    traceItem,
    traceOut,
    uploadInspM,
    urls,
    useBook,
    useComments,
    useMessenger,
    useStories,
    verifyCta,
    voiceHits,
    when
  } = ctx;
  const [pickedPresetId, setPickedPresetId] = useState<string | null>(null);
  useEffect(() => {
    setPickedPresetId(null);
  }, [selectedId, item?.bg_preset_id, item?.layout_preset_id, item?.style_id, item?.visual_pack_id, item?.style_apply_mode]);
  const committedStylePresetId = committedPresetId(
    styleApplyMode,
    catalog?.bg_presets || [],
    bgPresetId || item?.bg_preset_id || "",
    item?.style_id || styleId,
    item?.visual_pack_id || visualPackId,
    item?.layout_preset_id,
  );
  const galleryPresetId = pickedPresetId ?? committedStylePresetId;
  const stylePresetDirty = pickedPresetId !== null && pickedPresetId !== committedStylePresetId;
  const isCzasotekstItem = item?.kind === "czasotekst";
  const czasotekstForms = catalog?.czasotekst_forms || [];
  const pickCzasotekstForm = (id: string) => {
    setCzasotekstFormId?.(id);
    const form = czasotekstForms.find(
      (row: { id: string; default_funnel?: string }) => row.id === id,
    );
    const defaultFunnel = String(form?.default_funnel || "").toLowerCase();
    if (defaultFunnel === "tofu" || defaultFunnel === "mofu" || defaultFunnel === "bofu") {
      setFunnel(defaultFunnel);
      setFunnelPicked(true);
    }
    if (selectedId && isCzasotekstItem) {
      templateM.mutate({ czasotekst_form_id: id });
    }
  };
  return (
        <TabsContent value="brief" className="mt-0">
        <StudioSplit
          left={
        <Card id="brief" className="border-slate-200 bg-white shadow-sm">
          <CardHeader>
            <CardTitle className="flex items-center justify-between gap-2 text-base text-slate-900">
              <span>Brief</span>
              {!showPicker && activeMode ? (
                <button
                  type="button"
                  className="text-xs font-normal text-muted-foreground underline-offset-2 hover:underline"
                  onClick={changeTrack}
                >
                  Zmień przebieg
                </button>
              ) : null}
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {showPicker ? (
              <div id="studio-track" className="space-y-3">
                <p className="text-sm text-muted-foreground">{STUDIO_TIPS.trackPick}</p>
                <div className="grid gap-3 md:grid-cols-2">
                  <button
                    type="button"
                    className="rounded-lg border-2 border-brand/40 bg-brand/5 p-4 text-left shadow-sm ring-1 ring-brand/10 hover:border-brand"
                    onClick={() => pickTrack("operator")}
                  >
                    <span className="mb-1 inline-block rounded bg-brand/15 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-brand">
                      Teraz
                    </span>
                    <div className="mb-2 flex items-center gap-2 text-sm font-semibold">
                      <PenLine className="h-4 w-4" />
                      Własny pomysł i tekst
                    </div>
                    <p className="text-xs text-muted-foreground">{STUDIO_TIPS.trackOwn}</p>
                  </button>
                  <button
                    type="button"
                    className="rounded-lg border border-dashed border-slate-300 bg-slate-50/80 p-4 text-left hover:border-slate-400"
                    onClick={() => pickTrack("ai")}
                  >
                    <span className="mb-1 inline-block rounded bg-slate-200/80 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate-600">
                      Alternatywa
                    </span>
                    <div className="mb-2 flex items-center gap-2 text-sm font-semibold">
                      <Sparkles className="h-4 w-4" />
                      Pełny przebieg z AI
                    </div>
                    <p className="text-xs text-muted-foreground">{STUDIO_TIPS.trackAi}</p>
                  </button>
                </div>
              </div>
            ) : (
              <>
            <p className="text-xs text-muted-foreground">
              {isOperator
                ? "Wklej szkic i zredaguj. Nic nie wybierasz w parametrach = system dobierze ze szkicu."
                : "Najpierw szkic lub notatka. Parametry i źródła poniżej są opcjonalne."}
            </p>
            <StudioSection
              role="next"
              id="studio-primary-cta"
              title={isOperator ? "Szkic na ściany" : "Start koncepcji"}
              hint={
                isOperator
                  ? "Źródło ścian. Redakcja: 1:1 z wyjątkiem słabego haka i sanitizera listy."
                  : "Brief + źródła. Złóż 4 koncepcje, potem wybierzesz kartę."
              }
            >
              <div>
                <FieldLabel
                  tip={
                    isOperator
                      ? "Źródło ścian. Redakcja ze szkicu, nie surowy dump bez bramki haka."
                      : "Opcjonalna notatka. Analiza dobiera rytm, nie finalne copy."
                  }
                  icon={StickyNote}
                  tone="muted"
                >
                  Wklej szkic
                </FieldLabel>
                <textarea
                  className="min-h-[140px] w-full rounded-md border border-input bg-transparent p-2 text-sm"
                  placeholder={"Kiedyś…\nTeraz…\n1. …"}
                  value={draftText}
                  onChange={(e) => setDraftText(e.target.value)}
                />
              </div>
              {!isAiTrack ? (
                <div className="mt-3 space-y-1.5">
                  <FieldLabel tip="Ile wolno zmienić przy Zredaguj. Krytyka pod zasięg zawsze." icon={PenLine} tone="muted">
                    Tryb redakcji
                  </FieldLabel>
                  <div className="flex flex-wrap gap-1.5">
                    {[
                      { id: "literal", label: "Dosłownie", tip: "Ściany 1:1 ze szkicu (+ sanitizer i harden haka)." },
                      { id: "hook_close", label: "Hak + close", tip: "Środek ze szkicu; hak i ostatni close wolno." },
                      { id: "reach", label: "Pod zasięg", tip: "Wolno skracać beaty; fakty i głos zostają." },
                    ].map((row) => (
                      <Chip
                        key={row.id}
                        active={draftEditMode === row.id}
                        onClick={() => setDraftEditMode(row.id)}
                        tip={row.tip}
                        tone="brand"
                      >
                        {row.label}
                      </Chip>
                    ))}
                  </div>
                  <p className="text-xs text-muted-foreground">
                    {draftEditMode === "literal"
                      ? "Dosłownie: treść ścian ze szkicu. Sanitizer i mocniejszy hak zostają."
                      : draftEditMode === "reach"
                        ? "Pod zasięg: skróty i kolejność pod swipe; bez zmyślania sceny."
                        : "Hak + close: środkowe ściany ze szkicu; slajd 1 i close mogą wyjść mocniej."}
                  </p>
                  {item?.discussion?.draft_critique ? (
                    <div
                      className={
                        item.discussion.draft_critique.verdict === "kill"
                          ? "rounded-md border border-rose-300 bg-rose-50 p-2.5 text-sm"
                          : item.discussion.draft_critique.verdict === "fix"
                            ? "rounded-md border border-amber-300 bg-amber-50 p-2.5 text-sm"
                            : "rounded-md border border-emerald-200 bg-emerald-50/60 p-2.5 text-sm"
                      }
                    >
                      <p className="font-medium text-slate-900">
                        Krytyka: {item.discussion.draft_critique.verdict || "?"}
                        {item.discussion.draft_critique.hook_hardened ? " · hak wzmocniony" : ""}
                      </p>
                      {item.discussion.draft_critique.brutal ? (
                        <p className="mt-1 text-slate-800">{item.discussion.draft_critique.brutal}</p>
                      ) : null}
                      {!!item.discussion.draft_critique.must_change?.length && (
                        <ul className="mt-1 list-disc pl-4 text-xs text-slate-800">
                          {item.discussion.draft_critique.must_change.map((row, i) => (
                            <li key={i}>{row}</li>
                          ))}
                        </ul>
                      )}
                      {item.quality_flags?.includes("needs_idea_fix") ? (
                        <p className="mt-1 text-xs font-medium text-rose-800">
                          needs_idea_fix: zmień pomysł zanim shipniesz.
                        </p>
                      ) : null}
                    </div>
                  ) : null}
                </div>
              ) : null}
              <div className="mt-3 grid gap-3 xl:grid-cols-12 xl:items-end">
                <div className="xl:col-span-3">
                  <FieldLabel tip={STUDIO_TIPS.note} icon={StickyNote} tone="muted">
                    Notatka
                  </FieldLabel>
                  <Input
                    placeholder="notatka (scena, rytm, do kogo…)"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                  />
                </div>
                <div className="flex flex-col gap-2 xl:col-span-5">
                  <p className="text-[11px] text-muted-foreground">
                    Format: karuzela (ściany) albo czasotekst (główna treść w opisie + pętla wideo).
                  </p>
                  <div className="space-y-1.5">
                    <p className="text-[11px] font-medium text-slate-700">Forma czasotekstu</p>
                    <div className="flex flex-wrap gap-1.5">
                      {czasotekstForms.map((form: { id: string; label: string; tip?: string; structure?: string }) => (
                        <Chip
                          key={form.id}
                          active={czasotekstFormId === form.id}
                          onClick={() => pickCzasotekstForm(form.id)}
                          tip={form.tip || form.structure || form.label}
                          tone="brand"
                        >
                          {form.label}
                        </Chip>
                      ))}
                    </div>
                  </div>
                  {isAiTrack ? (
                    <>
                      <AiActionButton
                        label="Nowa karuzela · 4 koncepcje"
                        io="concepts"
                        running={conceptsRunning}
                        failed={createM.isError || item?.llm_status === "error"}
                        onClick={() => (conceptsRunning ? setAiJob("concepts") : startConcepts())}
                        icon={<Sparkles className="mr-2 h-4 w-4" />}
                      />
                      <AiActionButton
                        label="Nowy czasotekst"
                        io="caption"
                        variant="outline"
                        running={
                          (createM.isPending && createM.variables === "czasotekst") ||
                          czasotekstCopyM?.isPending ||
                          item?.llm_status === "czasotekst_copy"
                        }
                        failed={
                          (createM.isError && createM.variables === "czasotekst") ||
                          czasotekstCopyM?.isError
                        }
                        onClick={() => startCzasotekst()}
                      />
                    </>
                  ) : (
                    <>
                      <AiActionButton
                        label="Zredaguj slajdy"
                        io="fromDraft"
                        running={fromDraftRunning}
                        failed={fromDraftM.isError || item?.llm_status === "error"}
                        disabled={copyBusy || !draftText.trim()}
                        onClick={() => clickAi("fromDraft", () => fromDraftM.mutate())}
                        icon={<PenLine className="mr-2 h-4 w-4" />}
                      />
                      <AiActionButton
                        label="Nowy czasotekst"
                        io="caption"
                        variant="outline"
                        running={
                          (createM.isPending && createM.variables === "czasotekst") ||
                          czasotekstCopyM?.isPending ||
                          item?.llm_status === "czasotekst_copy"
                        }
                        failed={
                          (createM.isError && createM.variables === "czasotekst") ||
                          czasotekstCopyM?.isError
                        }
                        onClick={() => startCzasotekst()}
                      />
                      <p className="text-[11px] text-muted-foreground">
                        Szkic idzie do gęstego opisu (caption). Na ekranie zostaje krótki hak.
                      </p>
                    </>
                  )}
                </div>
              </div>
            </StudioSection>
            <details className="rounded-md border border-dashed border-slate-300 bg-slate-50/50 open:bg-white">
              <summary className="cursor-pointer list-none px-3 py-2.5 text-sm font-medium text-slate-800 marker:content-none [&::-webkit-details-marker]:hidden">
                Parametry (opcjonalnie · system dopasuje ze szkicu)
              </summary>
              <div className="space-y-4 border-t border-slate-200 px-3 py-3">
            <div>
              <FieldLabel tip={STUDIO_TIPS.pain} icon={HeartPulse} tone="warning">
                Ból
              </FieldLabel>
              <p className="mb-1.5 text-xs text-muted-foreground">
                {painPicked ? "Wybrane ręcznie." : "Auto ze szkicu, dopóki nic nie klikniesz."}
              </p>
              <div className="flex flex-wrap gap-1.5">
                <Chip
                  active={painPicked && !pain}
                  onClick={() => {
                    setPain("");
                    setPainPicked(true);
                  }}
                  tip={STUDIO_TIPS.allPains}
                  tone="warning"
                >
                  wszystkie
                </Chip>
                {(catalog?.pains || []).map((p) => (
                  <Chip
                    key={p.id}
                    active={painPicked && pain === p.id}
                    onClick={() => {
                      setPain(p.id);
                      setPainPicked(true);
                    }}
                    tip={`${p.id}: ${p.label}. Filtruje komentarze, Messenger i historyjki.`}
                    tone="warning"
                  >
                    {p.id} {p.label}
                  </Chip>
                ))}
              </div>
            </div>
            <div>
              <FieldLabel tip={STUDIO_TIPS.sku} icon={ShoppingBag} tone="brand">
                SKU
              </FieldLabel>
              <p className="mb-1.5 text-xs text-muted-foreground">
                {skuPicked ? "Wybrane ręcznie." : "Auto: pakiet ebooków, dopóki nic nie klikniesz."}
              </p>
              <div className="flex flex-wrap gap-1.5">
                {(catalog?.skus || []).map((s) => (
                  <Chip
                    key={s.id}
                    active={skuPicked && sku === s.id}
                    onClick={() => {
                      setSku(s.id);
                      setSkuPicked(true);
                    }}
                    tip={`${s.label}. Landing zamykający karuzelę.`}
                    tone="brand"
                  >
                    {s.label}
                  </Chip>
                ))}
              </div>
            </div>
            <div>
              <FieldLabel tip="Warstwa lejka na tej publikacji. Mix tygodnia liczy TOFU / MOFU / BOFU." icon={LayoutGrid} tone="primary">
                Lejek
              </FieldLabel>
              <p className="mb-1.5 text-xs text-muted-foreground">
                {funnelPicked ? "Wybrane ręcznie." : "Auto ze szkicu (zwykle MOFU)."}
              </p>
              <div className="flex flex-wrap gap-1.5">
                {([
                  ["tofu", "TOFU"],
                  ["mofu", "MOFU"],
                  ["bofu", "BOFU"],
                ] as const).map(([id, label]) => (
                  <Chip
                    key={id}
                    active={funnelPicked && funnel === id}
                    onClick={() => {
                      setFunnel(id);
                      setFunnelPicked(true);
                    }}
                    tip={label}
                    tone="primary"
                  >
                    {label}
                  </Chip>
                ))}
              </div>
            </div>
            <div>
              <FieldLabel tip={STUDIO_TIPS.ctaIntent} icon={MessageCircle} tone="primary">
                Intencja w podpisie
              </FieldLabel>
              <p className="mb-1.5 text-xs text-muted-foreground">
                {ctaTouched
                  ? "Nadpisane chipem. Jeden CTA."
                  : "Nic nie wybrane: system dobierze ze szkicu / bólu / typu."}
              </p>
              <div className="flex flex-wrap gap-1.5">
                {(
                  [
                    ["save", "Zapisz"],
                    ["send", "Wyślij"],
                    ["comment", "Komentarz"],
                  ] as const
                ).map(([id, label]) => (
                  <Chip
                    key={id}
                    active={Boolean(ctaTouched && ctaIntent === id)}
                    onClick={() => {
                      setCtaIntent(id);
                      setCtaTouched(true);
                      if (selectedId) ctaM.mutate({ cta_intent: id, close_mode: effectiveClose });
                    }}
                    tip={label}
                    tone="primary"
                  >
                    {label}
                  </Chip>
                ))}
              </div>
            </div>
            {!isCzasotekstItem ? (
            <>
            <div>
              <FieldLabel tip={STUDIO_TIPS.closeMode} icon={LayoutGrid} tone="primary">
                Tryb ostatniego slajdu
              </FieldLabel>
              <div className="flex flex-wrap gap-1.5">
                {(
                  [
                    ["caption_only", "Tylko podpis"],
                    ["soft_action", "Pudełko Zapisz/Wyślij"],
                    ["slide_cta", "CTA na slajdzie"],
                  ] as const
                ).map(([id, label]) => (
                  <Chip
                    key={id}
                    active={Boolean(ctaTouched && closeMode === id)}
                    onClick={() => {
                      setCloseMode(id);
                      setCtaTouched(true);
                      if (selectedId) ctaM.mutate({ cta_intent: effectiveIntent, close_mode: id });
                    }}
                    tip={label}
                    tone="primary"
                  >
                    {label}
                  </Chip>
                ))}
              </div>
            </div>
            <div>
              <StudioSection role="optional" title="A/B" hint={STUDIO_TIPS.ab}>
              <div className="flex flex-wrap gap-1.5">
                {(
                  [
                    ["", "bez pary"],
                    ["hook", "hak"],
                    ["length", "długość"],
                    ["cover", "okładka"],
                    ["cta", "CTA"],
                  ] as const
                ).map(([id, label]) => (
                  <Chip
                    key={id || "none"}
                    active={abVariable === id}
                    onClick={() => {
                      setAbVariable(id);
                      if (selectedId) ctaM.mutate({ ab_variable: id, ab_pair_id: abPairId });
                    }}
                    tip={label}
                    tone="muted"
                  >
                    {label}
                  </Chip>
                ))}
              </div>
              {abVariable ? (
                <Input
                  className="mt-2"
                  placeholder="id pary, np. w36-dlugosc"
                  value={abPairId}
                  onChange={(e) => setAbPairId(e.target.value)}
                  onBlur={() => {
                    if (selectedId) ctaM.mutate({ ab_variable: abVariable, ab_pair_id: abPairId });
                  }}
                />
              ) : null}
              </StudioSection>
            </div>
            <div>
              <FieldLabel tip={STUDIO_TIPS.type} icon={LayoutGrid} tone="primary">
                Typ karuzeli
              </FieldLabel>
              <p className="mb-1.5 text-xs text-muted-foreground">
                {formatPicked
                  ? "Typ zablokowany chipem."
                  : "Auto ze szkicu (signals / vs-echo / question-list). Pusty chip = mieszanka."}
              </p>
              <div className="grid gap-2 sm:grid-cols-2 xl:grid-cols-4">
                <ChoiceCard
                  active={formatPicked && !formatId}
                  onClick={() => {
                    setFormatId("");
                    setFormatPicked(true);
                  }}
                  title="mieszanka"
                  excerpt="4 kąty, często 4 typy. Nie zawsze story."
                  tip={STUDIO_TIPS.mix}
                />
                {catalogTypes.map((fmt) => (
                  <ChoiceCard
                    key={fmt.id}
                    active={formatPicked && formatId === fmt.id}
                    onClick={() => {
                      setFormatId(fmt.id);
                      setFormatPicked(true);
                    }}
                    title={fmt.label}
                    excerpt={fmt.hint}
                    tip={fmt.hint || fmt.label}
                  />
                ))}
              </div>
            </div>
            <div>
              <FieldLabel tip={STUDIO_TIPS.visualPack} icon={Palette} tone="secondary">
                Szablon wizualny
              </FieldLabel>
              <p className="mb-1.5 text-xs text-muted-foreground">
                {visualPackId
                  ? "Paczka rytmu + paleta. Możesz potem zmienić sam styl."
                  : "Opcjonalnie. Bez paczki: Krem + dotychczasowa heurystyka składu."}
              </p>
              <div className="mb-3 flex flex-wrap gap-2">
                <Chip
                  active={!visualPackId}
                  onClick={() => setVisualPackId("")}
                  tip="Bez paczki rytmu"
                >
                  Bez paczki
                </Chip>
                {(catalog?.visual_packs || []).map((pack) => (
                  <Chip
                    key={pack.id}
                    active={visualPackId === pack.id}
                    onClick={() => {
                      setVisualPackId(pack.id);
                      if (pack.style_id) {
                        setStyleId(pack.style_id);
                        setStylePicked(true);
                      }
                    }}
                    tip={pack.hint || pack.label}
                  >
                    {pack.label}
                  </Chip>
                ))}
              </div>
              <FieldLabel tip={STUDIO_TIPS.style} icon={Palette} tone="secondary">
                Styl wizualny
              </FieldLabel>
              <p className="mb-1.5 text-xs text-muted-foreground">
                {stylePicked ? "Wybrane ręcznie." : "Auto: Krem Kasi, dopóki nic nie klikniesz."}
              </p>
              <p className="mb-1.5 text-xs text-muted-foreground">{STUDIO_TIPS.hookVisual}</p>
              <div className="grid gap-2 sm:grid-cols-2 xl:grid-cols-3">
                {(catalog?.styles || []).map((st) => (
                  <ChoiceCard
                    key={st.id}
                    active={stylePicked && styleId === st.id}
                    onClick={() => {
                      setStyleId(st.id);
                      setStylePicked(true);
                    }}
                    title={st.label}
                    excerpt={st.hint}
                    tip={st.hint || st.label}
                    swatch={{ bg: st.bg, accent: st.accent, ink: st.ink }}
                  />
                ))}
              </div>
              <FieldLabel tip={STUDIO_TIPS.bgMode} icon={Images} tone="secondary">
                Tło slajdów
              </FieldLabel>
              <div className="mt-1 flex flex-wrap gap-2">
                <Chip
                  active={bgMode === "flat"}
                  onClick={() => {
                    setBgMode("flat");
                    if (selectedId) templateM.mutate({ bg_mode: "flat" });
                  }}
                  tip="Płaski papier + ziarno. Bez Gemini."
                >
                  Druk
                </Chip>
                <Chip
                  active={bgMode === "gemini"}
                  onClick={() => {
                    setBgMode("gemini");
                    if (selectedId) templateM.mutate({ bg_mode: "gemini", bg_unique_count: 1 });
                  }}
                  tip="Tło Gemini na żądanie. Domyślnie jedno na zestaw."
                >
                  Gemini
                </Chip>
              </div>
              <div className="mt-3 min-w-0 space-y-3">
                <BgPresetPicker
                  presets={catalog?.bg_presets || []}
                  value={galleryPresetId}
                  mode={styleApplyMode}
                  applyDirty={stylePresetDirty}
                  applyBusy={templateM.isPending}
                  onApply={() => {
                    if (!selectedId || pickedPresetId === null) return;
                    const preset = (catalog?.bg_presets || []).find((p) => p.id === pickedPresetId);
                    const body = buildTemplatePatchFromPreset(styleApplyMode, pickedPresetId, preset);
                    if (body.bg_preset_id != null) setBgPresetId(body.bg_preset_id);
                    if (body.style_id) {
                      setStyleId(body.style_id);
                      setStylePicked(true);
                    }
                    if (body.visual_pack_id != null) setVisualPackId(body.visual_pack_id);
                    templateM.mutate(body, {
                      onSuccess: () => setPickedPresetId(null),
                    });
                  }}
                  onModeChange={(m) => {
                    setStyleApplyMode(m);
                    setPickedPresetId(null);
                    if (selectedId) templateM.mutate({ style_apply_mode: m });
                  }}
                  onChange={(id) => {
                    setPickedPresetId(id);
                  }}
                />
                <BgPlacementPicker
                  placements={catalog?.bg_placements || []}
                  value={bgPlacementId}
                  onChange={(id) => {
                    setBgPlacementId(id);
                    if (selectedId) templateM.mutate({ bg_placement_id: id });
                  }}
                />
              </div>
            </div>
            </>
            ) : null}
            {isAiTrack ? (
            <>
            <SourceSection
              title="Książka"
              count={useBook ? bookSectionHits.length : 0}
              hint="Opcjonalnie. Narzędzie jest filtrem w tej sekcji, nie musi pokrywać wybranego bólu. Głos Kasi jest tu, gdy książka jest włączona."
              tip={STUDIO_TIPS.book}
              checked={useBook}
              onChecked={setUseBook}
              icon={BookOpen}
              tone="brand"
            >
              <div className="mb-3">
                <FieldLabel tip={STUDIO_TIPS.bookWhich} icon={BookOpen} tone="brand">
                  Która książka
                </FieldLabel>
                <div className="flex flex-wrap gap-1.5">
                  <Chip active={!book} onClick={() => setBook("")} tip={STUDIO_TIPS.allBooks} tone="brand">
                    wszystkie książki
                  </Chip>
                  {(catalog?.books || []).map((b) => (
                    <Chip
                      key={b.id}
                      active={book === b.id}
                      onClick={() => setBook(b.id)}
                      tip={b.label || b.id}
                      tone="brand"
                    >
                      {b.label || b.id}
                    </Chip>
                  ))}
                </div>
              </div>
              <div>
                <FieldLabel tip={STUDIO_TIPS.tool} icon={Wrench} tone="brand">
                  Narzędzie (opcjonalnie)
                </FieldLabel>
                <div className="grid gap-2 sm:grid-cols-2 xl:grid-cols-3">
                  <ChoiceCard
                    active={!tool}
                    onClick={() => setTool("")}
                    title="bez konkretnego narzędzia"
                    tip={STUDIO_TIPS.tool}
                  />
                  {(catalog?.tools || []).map((t) => (
                    <ChoiceCard
                      key={t.id}
                      active={tool === t.id}
                      onClick={() => setTool(t.id)}
                      title={t.label}
                      meta={t.source || t.book_id}
                      excerpt={t.excerpt}
                      tip={t.excerpt || t.label}
                    />
                  ))}
                </div>
              </div>
              <div className="mt-3">
                <SourceHits
                  hits={bookSectionHits}
                  loading={sourcesQ.isFetching}
                  empty={SOURCE_EMPTY.book}
                />
              </div>
            </SourceSection>
            <SourceSection
              title="Komentarze"
              count={useComments ? commentHits.length : 0}
              hint="Sceny z rolek. Osobne źródło, nie wymaga książki."
              tip={STUDIO_TIPS.comments}
              checked={useComments}
              onChecked={setUseComments}
              icon={MessageCircle}
              tone="success"
            >
              <SourceHits
                hits={commentHits}
                loading={sourcesQ.isFetching}
                empty={SOURCE_EMPTY.comments}
              />
            </SourceSection>
            <SourceSection
              title="Messenger"
              count={useMessenger ? messengerHits.length : 0}
              hint="Historie z DM. Osobne źródło, nie wymaga książki."
              tip={STUDIO_TIPS.messenger}
              checked={useMessenger}
              onChecked={setUseMessenger}
              icon={MessageSquare}
              tone="primary"
            >
              <SourceHits
                hits={messengerHits}
                loading={sourcesQ.isFetching}
                empty={SOURCE_EMPTY.messenger}
              />
            </SourceSection>
            <SourceSection
              title="Historyjki Kasi"
              count={useStories ? storyHits.length : 0}
              hint="Czwarty korpus, równy książce i komentarzom. Nie nadpisuje MOFU. Kanon, nie inbox."
              tip={STUDIO_TIPS.stories}
              checked={useStories}
              onChecked={setUseStories}
              icon={Sparkles}
              tone="warning"
            >
              <SourceHits
                hits={storyHits}
                loading={sourcesQ.isFetching}
                empty={SOURCE_EMPTY.stories}
              />
            </SourceSection>
            </>
            ) : null}
              </div>
            </details>
            <div className="grid gap-3">
              <StudioSection
                role="optional"
                title="Inspiracja (permalink)"
                hint={STUDIO_TIPS.inspiration}
              >
                <div className="grid gap-3 xl:grid-cols-12">
                <div className="xl:col-span-6">
                  <FieldLabel tip={STUDIO_TIPS.inspiration} icon={Link2} tone="muted">
                    Permalink IG / FB / Pinterest
                  </FieldLabel>
                  <textarea
                    className="min-h-[72px] w-full rounded-md border border-input bg-transparent p-2 text-sm"
                    placeholder={"https://www.instagram.com/p/...\nhttps://www.facebook.com/.../posts/..."}
                    value={urls}
                    onChange={(e) => setUrls(e.target.value)}
                  />
                </div>
                <div className="xl:col-span-12">
                  <FieldLabel tip={STUDIO_TIPS.inspiration} icon={Palette} tone="muted">
                    Co wolno wziąć z referencji
                  </FieldLabel>
                  <div className="flex flex-wrap gap-1.5">
                    {BORROW_CHIPS.map((chip) => (
                      <Chip
                        key={chip.id}
                        active={Boolean(borrow[chip.id])}
                        onClick={() => {
                          const next = { ...borrow, [chip.id]: !borrow[chip.id] };
                          setBorrow(next);
                          if (selectedId) borrowM.mutate(next);
                        }}
                        tip={chip.tip}
                        tone={chip.id === "colors" || chip.id === "photo_kind" ? "warning" : "muted"}
                      >
                        {chip.label}
                      </Chip>
                    ))}
                  </div>
                </div>
                </div>
              </StudioSection>
              {isAiTrack ? (
                <StudioSection role="optional" title="Inne starty" hint="Nie blokują głównej ścieżki karuzeli.">
                  <div className="flex flex-col gap-2">
                    <AiActionButton
                      label="Analizuj układ"
                      io="layoutPlan"
                      variant="outline"
                      running={layoutPlanRunning}
                      failed={layoutPlanM.isError}
                      disabled={!draftText.trim() && !selectedId}
                      onClick={() => clickAi("layoutPlan", () => layoutPlanM.mutate())}
                    />
                    <AiActionButton
                      label="Nowy post 1-grafika"
                      io="post"
                      variant="outline"
                      running={createM.isPending && createM.variables === "feed_post"}
                      failed={createM.isError && createM.variables === "feed_post"}
                      onClick={() => startPost()}
                    />
                  </div>
                </StudioSection>
              ) : null}
            </div>
              </>
            )}
          </CardContent>
        </Card>
          }
          right={
            showPicker ? (
              <Card className="border-slate-200 bg-white shadow-sm">
                <CardHeader>
                  <CardTitle className="text-base text-slate-900">Utworzone</CardTitle>
                </CardHeader>
                <CardContent>
                  <CarouselQueueList
                    items={listQ.data?.items || []}
                    activeId={selectedId}
                    empty="Brak w kolejce. Wybierz przebieg po lewej i złóż nową."
                    onOpen={openExisting}
                    onNext={(id) => fromPubM.mutate(id)}
                    onRate={(id, rating) => ratingM.mutate({ rating })}
                    onRetro={(id) => clickAi("retro", () => retroM.mutate({ id, phase: "discussion" }))}
                    onDelete={askDelete}
                    onRetry={(row) => {
                      setSelectedId(row.id);
                      clickAi("publish", () => retryPublishM.mutate({ id: row.id }));
                    }}
                    retryPendingId={
                      retryPublishM.isPending ? retryPublishM.variables?.id : undefined
                    }
                    deletePendingId={deleteM.isPending ? deleteM.variables : undefined}
                  />
                </CardContent>
              </Card>
            ) : (
              <BriefPreview
                track={isOperator ? "własny szkic" : "pełne AI"}
                painLabel={
                  painPicked ? (pain ? catalogLabel(catalog?.pains, pain) : "wszystkie") : "auto ze szkicu"
                }
                skuLabel={skuPicked ? catalogLabel(catalog?.skus, sku, sku || "brak") : "auto (pakiet)"}
                formatLabel={
                  formatPicked
                    ? formatId
                      ? catalogLabel(catalogTypes, formatId)
                      : "mieszanka"
                    : "auto ze szkicu"
                }
                styleLabel={
                  stylePicked ? catalogLabel(catalog?.styles, styleId, styleId || "brak") : "auto (Krem Kasi)"
                }
                bgMode={bgMode}
                funnel={funnelPicked ? funnel || "brak" : "auto"}
                ctaIntent={ctaTouched ? effectiveIntent : "auto"}
                closeMode={ctaTouched ? effectiveClose : "auto"}
                note={note}
                sources={sourceHits}
              />
            )
          }
        />
        </TabsContent>

  );
}

